import React from "react"
import { Button, Form } from "react-bootstrap"
import { blockingFetchService } from "../../../lib/blockingFetch"
import { getOrganization, validateDateState, validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FormControlInlineTextArea from "../../fragments/FormControl.Inline.TextArea"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import FontAwesome from "react-fontawesome"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import moment from "moment"
import FormControlInlineDate from "../../fragments/FormControl.Inline.Date"
import { DATE_FORMAT_STR } from "../../../lib/utils"

class FormGLClosure extends React.Component {

  constructor(props) {

    super(props)
    const { glClosure } = this.props,
      isNew = !glClosure,
      organization = getOrganization()

    this.state = {
      isNew,
      running: false,
      success: false,
      error: null,
      minDate: organization ? moment(organization.openedOn).format(DATE_FORMAT_STR) : '',
      closingDate: moment(isNew ? Date.now() : glClosure.closingDate).format(DATE_FORMAT_STR),
      comments: isNew ? '' : glClosure.comments,

      closingDateValidationState: VALIDATION_TYPE.SUCCESS,
      commentsValidationState: isNew || !glClosure.comments ? VALIDATION_TYPE.NULL : VALIDATION_TYPE.SUCCESS,
    }
  }

  componentDidMount() {
    this.fetchLastClosingDate()
  }

  fetchLastClosingDate = () => blockingFetchService(
    accessToken => apiServerApi.getLastClosingDate(accessToken),
    minDate => {
      if (minDate) {
        this.setState({ minDate: moment(minDate).add(1, 'day').format(DATE_FORMAT_STR) })
      }
    },
    _ => {},
    _ => {}
  )

  closingDateChanged = closingDate => this.setState({
    closingDate,
    closingDateValidationState: validateDateState(closingDate, this.state.minDate),
    error: null,
  })

  commentsChanged = comments => this.setState({
    comments,
    commentsValidationState: validateTextState(comments, this.state.isNew),
    error: null,
  })

  validateAllValues = () => {

    const { closingDate, comments, isNew, minDate } = this.state
    this.setState({
      commentsValidationState: validateTextState(comments, isNew),
    })

    if (isNew) {
      this.setState({
        closingDateValidationState: validateDateState(closingDate, minDate),
      })
    }
  }

  valid = () => {

    const { closingDate, comments, isNew, minDate } = this.state

    return isNew ? (
      validateDateState(closingDate, minDate) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(comments, true) !== VALIDATION_TYPE.ERROR
    ) : (
      validateTextState(comments, false) === VALIDATION_TYPE.SUCCESS
    )
  }

  saveClicked = () => {

    if(this.valid()) {
      this.saveGlClosure()
    }
    else {
      this.validateAllValues();
      this.setState({ error: 'Some fields are incorrect.' })
    }
  }

  saveGlClosure = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { closingDate, comments, isNew } = this.state,
    data = { closingDate, comments },
    { glClosure } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.createGLClosure(accessToken, data)
        : apiServerApi.updateGLClosure(accessToken, glClosure.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push('/glclosures'), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderForm = () => {
    const { isNew, error, success, running, closingDate, comments, closingDateValidationState,
      commentsValidationState, minDate } = this.state

    return (
      <div className="simple-form max-width-700 mx-auto mb-20">
        <Form horizontal onSubmit={e => { e.preventDefault(); this.saveClicked()}}>

          <h3 className="text-center">
            { isNew ? 'New GL closure' : 'Update GL closure' }
          </h3>
          <hr />

          <FormControlInlineDate controlId="closingDate" validationState={ closingDateValidationState }
            label='Closing date' placeholder='Choose a date' value={ closingDate }
            onChange={ this.closingDateChanged }
            helpText={ closingDateValidationState === VALIDATION_TYPE.ERROR ? 'Choose a valid date' : '' }
            min={ minDate }
            max={ moment().format(DATE_FORMAT_STR) }
            disabled={ !isNew }
          />

          <FormControlInlineTextArea
            controlId='comments' validationState={ commentsValidationState }
            label={'Comments' + (isNew ? ' (Optional)' : '')} value={ comments }
            onChange={ this.commentsChanged }
            helpText={ commentsValidationState === VALIDATION_TYPE.ERROR ? 'Comments are required' : '' }
          />
        </Form>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <div className="align-right mt-30">
          <Button onClick={() => browserHistory.push('/glclosures')} className="w-100" disabled={ running }>
            <FontAwesome name='close' /> Cancel
          </Button>

          <Button bsStyle="success" onClick={ this.saveClicked } className="w-120 ml-10" disabled={ running }>
            <FontAwesome name='save' /> Save
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const { isNew } = this.state,
    dataBreadCrumbs = [{ url: '/accounting', title: 'Accounting' }, { url: '/glclosures', title: 'GL closures' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />
        { this.renderForm() }
      </div>
    )
  }
}

export default FormGLClosure



// WEBPACK FOOTER //
// ./src/components/Accounting/GLClosures/Form.js